export default __webpack_public_path__ + "static/media/36I-114281_-20920_0.596b9040.jpg";